<template>
  <div class="dragable_content">
    <draggable 
      class="list-group" 
      handle=".handle" 
      v-model="list" 
      v-bind="dragOptions" 
      @start="drag = true" 
      @end="drag = false" 
      item-key="fakeId">
      <template #item="{ element,index }">
        <div class="list-group-item-box">
          <div class="list-group-item">
            <div class="left">
              <ContentCard :key="element.fakeId" :cardData="element" :sendTarget="sendTarget"></ContentCard>
            </div>
            <div class="right">
              <el-icon class='icon handle'><Rank /></el-icon>
              <el-popconfirm v-if="element.sendContent?.length || element.filePaths?.length" title="确定删除此项吗?" @confirm="removeCard(element)">
                <template #reference>
                  <el-icon class="icon"><Delete /></el-icon>
                </template>
              </el-popconfirm>
              <el-icon v-else class="icon" @click="removeCard(element)"><Delete /></el-icon>
            </div>
          </div>
          <el-text class="no_text" type="primary"> {{ list.length - index }}</el-text>
        </div>
      </template>
    </draggable>
  </div>
</template>

<script setup>
import draggable from "vuedraggable";
import ContentCard from './contentCard.vue';
import { ref,computed } from 'vue';
import { getUid } from '@/utils/util.js'
const props =defineProps(['modelValue','sendTarget']);
const emit = defineEmits(['update:modelValue']);
const drag = ref(false)
const dragOptions = {
  animation: 200,
  group: "description",
  disabled: false,
  ghostClass: "ghost"
};
const list = computed({
  get:()=>props.modelValue.map(item=>{
    item.fakeId = item.fakeId || getUid();
    return item
  }),
  set: (val)=>{
    emit('update:modelValue',val);
  }
})
const removeCard = (element)=>{
  console.log(element)

  list.value = list.value.filter(item => item.fakeId != element.fakeId)
}



</script>

<style lang="less" scoped>
.list-group-item-box{
  position: relative;
  .no_text{
    position: absolute;
    top: 10px;
  }
}
.list-group-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0;
  padding: 10px 5px;
  &.ghost{
    opacity: 0.2;
    background-color: beige;
  }
  .left{
    width: 650px;
  }
  .right{
    width: 50px;
    // text-align: right;
    display: flex;
    justify-content: space-around;
    .icon{
      cursor: pointer;
    }
  }
}
</style>